<div class="root" *transloco="let t; read:'permit.prepare.completed'">
    <h1 class="root__heading" [innerHTML]="t('heading')"></h1>

    <div class="root__info-text" [innerHTML]="t('infoText')"></div>

    <a class="root__anchor" routerLink="..">{{ t("goBackAnchor") }}</a>
</div>
